module.exports = __webpack_public_path__ + "images/baab007222be9142dfbfe68a5986904d.jpg";


//////////////////
// WEBPACK FOOTER
// ../public/images/gift-categories/bestsellers.jpg
// module id = 1093
// module chunks = 0